import type { Feature } from 'util/stdtypes';

export const ChannelSettingsFeature: Feature = {
    name: 'Channel Settings',
    parentFeature: 'moddashboardsettings',
    key: 'channelsettings',
    providesConfig: {
        channelSettingsEnabled: true,
    },
};
